import type { PlanStrategyType } from '../types';
import { strategyMeta } from './meta';

export type { PlanStrategy } from './type';
export { getStrategy } from './getStrategy';
export { strategyMeta } from './meta';

export const strategyLabelMap: Record<PlanStrategyType, string> = Object.keys(strategyMeta).reduce(
  (acc: any, key: any) => {
    acc[key] = strategyMeta[key as PlanStrategyType].title;
    return acc;
  },
  {},
);
